import { Slider, TextField, Typography } from "@mui/material";
import debounce from "debounce";
import { useCallback, useState } from "react";

interface CustomSliderProps {
  min?: number;
  max?: number;
  label?: string;
  onChange?: Function;
}
export default function CustomSlider(props: CustomSliderProps) {
  const { max = 100000, label = "Slider Label", onChange = () => {} } = props;

  const [requested, setRequested] = useState<number[]>([0, max]);

  //eslint-disable-next-line
  const handleChange = useCallback(
    debounce((value: number[]) => {
      onChange(value);
    }, 1000),
    //eslint-disable-next-line
    []
  );

  return (
    <>
      <div
        className="horizontalCenter"
        style={{ columnGap: "20px", padding: "0px 10px" }}
      >
        <TextField
          type="number"
          id="outlined-basic"
          label="Min"
          variant="outlined"
          size="small"
          sx={{ height: "10px" }}
          value={requested[0]}
          inputMode="numeric"
          onChange={(event) => {
            setRequested([parseInt(event.target.value), requested[1]]);
            handleChange([parseInt(event.target.value), requested[1]]);
          }}
        />
        <div style={{ width: "100%" }}>
          <Typography
            id="area-slider"
            gutterBottom
            sx={{
              fontSize: "0.9rem",
              textAlign: "center",
              lineHeight: "0.8rem",
            }}
          >
            {label}
          </Typography>

          <Slider
            aria-labelledby="area-slider"
            value={requested}
            onChange={(event: Event, newValue: number | number[]) => {
              handleChange(newValue as number[]);
              setRequested(newValue as number[]);
            }}
            valueLabelDisplay="auto"
            max={max}
            min={0}
            step={100}
            sx={{ paddingTop: "0px" }}
            // getAriaValueText={requested.toString()}
          />
        </div>
        <TextField
          type="number"
          id="outlined-basic"
          label="Max"
          variant="outlined"
          size="small"
          sx={{ height: "10px" }}
          value={requested[1]}
          inputMode="numeric"
          onChange={(event) => {
            setRequested([requested[0], parseInt(event.target.value)]);
            handleChange([requested[0], parseInt(event.target.value)]);
          }}
        />
      </div>
    </>
  );
}
